import styled from 'styled-components';

export const Wrapper = styled.div.withConfig({ displayName: '-Wrapper' })`
	position: absolute;
	top: 0px;
	right: 0px;
	width: 550px;
	height: 100%;

	overflow: hidden;
`;
